export enum KeyPortVesselScope {
    ALL = 'all',
    SELECTED = 'selected',
}
